import { render } from "./FullContentBlock.vue?vue&type=template&id=79174e9f"
import script from "./FullContentBlock.vue?vue&type=script&lang=js"
export * from "./FullContentBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__